import { useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import logo from "../../assets/logo-black.png";
import dashboardIcon from "../../assets/dashboard-icon.png";
import userIcon from "../../assets/user-icon.png";
import senderIcon from "../../assets/sender-icon.png";
import receiverIcon from "../../assets/receiver-icon.png";
import customsIcon from "../../assets/agent-icon.png";
import declarationIcon from "../../assets/declaration-icon.png";
import collapseIcon from "../../assets/collapse-icon.png";
import paymentIcon from "../../assets/history-icon.png";


import './Sidebar.css';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setShowBackToDashboardButton } from '../../store/reducers'; 

import { gsap } from 'gsap';
import { useLanguage, getSidebarTranslation } from '../../hooks/useLanguage';

const Sidebar = ({isDarkMode, setIsDarkMode, isSidebarCollapsed, setIsSidebarCollapsed}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isSpanish] = useLanguage();

  const [navLinks] = useState([
    {
      name: 'home',
      path: '/',
      icon: dashboardIcon
    },
    {
      name: 'userManagement',
      path: '/user-management',
      icon: userIcon
    },
    {
      name: 'senderManagement',
      path: '/sender-management',
      icon: senderIcon
    },
    {
      name: 'receiversManagement',
      path: '/receiver-management',
      icon: receiverIcon
    },
    {
      name: 'customsAgent',
      path: '/customs-agent',
      icon: customsIcon
    },
    {
      name: 'declarationManagement',
      path: '/declaration-management',
      icon: declarationIcon
    },
    {
      name: 'creditHistory',
      path: '/credit-history',
      icon: paymentIcon
    },
  ]);

  const isActive = (path) => location.pathname === path;

  const handleNavLinkClick = () => {
    dispatch(setShowBackToDashboardButton(false));
  };

  // Animation
  useEffect(() => {
    const sections = document.querySelectorAll('.fadeUp');
    const tl = gsap.timeline();

    sections.forEach(section => {
      tl.to(section,
        {
          stagger: 0.15,
          duration: 0.15,
          opacity: 1,
          y: 0,
          ease: "back",
        }
      );
    });
  }, [location]);

 
  return (
    <div className={`sidebar ${isDarkMode ? 'dark-mode' : ''} ${isSidebarCollapsed && "sidebar-collapsed"}`}>
    <div className="sidebar-content">
      <div className='flex justify-between gap-2 items-center mb-10 sidebar-top px-3'>
      <div className="logo fadeUp"
      onClick={() => (navigate('/'))}>
        <img 
          src={logo} 
          alt="logo"
          className="logo-icon h-10"
        />
      </div>
      <div className="fadeUp  p-1.5 rounded-full cursor-pointer collapse-container"
      onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}>
        <img 
          src={collapseIcon} 
          alt="logo"
          className="logo-icon h-7"
        />
      </div>
      </div>

      <nav className='flex-1'>
        <ul className="space-y-2">
          {navLinks.map((link) => (
            <li key={link.path} className='fadeUp' >
              <Link
                to={link.path}
                onClick={handleNavLinkClick}
                className={`session-item flex items-center px-3 py-2 rounded-lg transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'active text-dark text-primary'
                    : ' '
                }`}
              >
                <img 
          src={link.icon} 
          alt="logo"
          className={`session-icon`}
        />
                <span className={`nav-text ${isActive(link.path) && ' font-bold'}`}>{getSidebarTranslation(link.name, isSpanish) || link.name.charAt(0).toUpperCase() + link.name.slice(1)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      </div>

    </div>
  );
};

export default Sidebar;